// Shared example payloads used as "Load sample" data across the Converter and
// the Editor. Kept in one place so both tools show the same reference data
// instead of drifting sample copies.
// Each one touches every value type the format supports, so switching source
// shows what "well-formed input" looks like, and each format uses the
// example where it's actually used in practice, so it reads as something
// you'd really work with rather than a toy fixture.

export const jsonSample = `{
  "id": 1024,
  "username": "jcapilla",
  "email": "julian@example.com",
  "isActive": true,
  "roles": ["admin", "editor"],
  "profile": {
    "firstName": "Julian",
    "city": "Madrid"
  }
}`

export const csvSample = `id,name,department,salary,isActive
1,Julian Capilla,Engineering,68000,true
2,Ana Torres,Marketing,54000,false`

export const yamlSample = `service: payments-api
port: 8080
debug: false
replicas: 3
allowedOrigins:
  - https://example.com
  - https://admin.example.com
database:
  host: db.internal
  ssl: true`

export const xmlSample = `<?xml version="1.0" encoding="UTF-8"?>
<product>
  <id>4521</id>
  <name>Wireless Mouse</name>
  <price>29.99</price>
  <inStock>true</inStock>
  <dimensions>
    <width>6.3</width>
    <height>3.4</height>
  </dimensions>
  <category>Electronics</category>
  <category>Accessories</category>
</product>`
